import React from 'react';
import IAPageView from './IAPage.View';

const IAPage = () => {
  return <IAPageView />;
};

export default IAPage;
